import { Typography, Box, AppBar, Toolbar, Button } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { SideBar } from '../components';
import '../style/home.scss';
import {
    Banner,
    ListScreen,
    FieldDetails,
    AddField,
    FieldRequest,
} from '.';

export const HomeScreen = () => {
    const [selectedTab, setSelectedTab] = useState('List');

    window.history.replaceState(null, `${selectedTab}`, `/${selectedTab}`);

    const renderTabItem = () => {
        switch (selectedTab) {
            case 'List':
                return <ListScreen setSelectedTab={setSelectedTab} />;
            case 'Banner':
                return <Banner />;
            case 'Field-request':
                return <FieldRequest setSelectedTab={setSelectedTab} />;
            case 'Field-details':
                return <FieldDetails setSelectedTab={setSelectedTab} />;
            case 'Add-field':
                return <AddField />;
        }
    };

    const logOut = () => { };

    return (
        <Box className="home">
            <AppBar className="appBar" position="relative">
                <Toolbar className="toolbar">
                    <Typography variant="h6">{selectedTab}</Typography>
                    <Button>Log Out</Button>
                </Toolbar>
            </AppBar>
            <Box className="screenRender">
                <SideBar setSelectedTab={setSelectedTab} selectedTab={selectedTab} />
                {renderTabItem()}
            </Box>
        </Box>
    );
};
